import { render, staticRenderFns } from "./TypeTabSw.vue?vue&type=template&id=672571ea&"
import script from "./TypeTabSw.vue?vue&type=script&lang=js&"
export * from "./TypeTabSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports